import { render, staticRenderFns } from "./writeOff.vue?vue&type=template&id=3a6c16f3&scoped=true&"
import script from "./writeOff.vue?vue&type=script&lang=js&"
export * from "./writeOff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6c16f3",
  null
  
)

export default component.exports